define('Components/ReinsuranceWidget/js/models/ReinsuranceWidgetInstanceModel',['jquery',
        'app',
        'WidgetInstanceModel',
        'UrlFactory'
    ],
    function ($, app, WidgetInstanceModel, UrlFactory) {
        return WidgetInstanceModel.extend({
            name:'ReinsuranceWidgetModel',
            getFormatedReinsurance: function() {
                var model = this
                var result = _([1, 2, 3, 4]).map(function(i) {
                    var aClassList = [],
                        comein = model.p('iscomein'+i),
                        opennewtab = model.p('opennewtab'+i),
                        hasAvis = model.p('hasavisverifiesreassurence'+i),
                        avisVal = app.c('_AVIS_VERIFIE_AVG_AVIS_',0),
                        avis = (hasAvis && avisVal) ? parseFloat(avisVal).toFixed(1) : false;

                    if(!!comein) aClassList.push('reinsurance-item--comein'); //
                    if(!!opennewtab) aClassList.push('ignore-routing');

                    if (hasAvis) {
                        if (model.p('avisverifiesreview'+i) === 'covid' ) {
                            avis = parseFloat(app.c('_AVIS_VERIFIE_AVG_AVIS_COVID_',0)).toFixed(1)
                        } else if (model.p('avisverifiesreview'+i) === 'quality' ){
                            avis = parseFloat(app.c('_AVIS_VERIFIE_AVG_AVIS_QUALITY_',0)).toFixed(1)
                        }else if (avis) {

                        }else{

                        }
                    }else{
                        avis = false;
                    }
                    return {
                        icon: model.p('iconreassurence'+i),
                        block: model.p('blockreassurence'+i),
                        tooltip: model.p('popupreassurence'+i),
                        avisVerifies: avis,
                        aClassList: aClassList.join(' '),
                        opennewtab: opennewtab ? 'target="_blank" rel=noopener':'',
                        url: model.p('urlreassurence'+i),
                    }
                })
                return _(result)
            }
        })
    });
